import { Transition } from "@headlessui/react";
import { MemoryRouter as Router } from "react-router-dom";
import { Route } from "react-router-dom";
import { Switch } from "react-router-dom";
import { FloatingActionButton } from "../FloatingActionButton";
import { SupportWidgetContainer } from "../SupportWidgetContainer";
import { useSupportWidgetContext } from "../SupportWidgetContext";
import { ChatBotView } from "../views/ChatBotView";
import { CreateConversationView } from "../views/CreateConversationView";
import { HomeView } from "../views/HomeView";

export const SupportWidgetPortalBody = () => {
  const { isOpen, toggleWidget } = useSupportWidgetContext();

  const onFabClick = () => {
    toggleWidget({ shouldTriggerOnWidgetClose: true });
  };

  return (
    <div className="fixed bottom-4 z-[60] flex flex-col" style={{ right: 48 }}>
      <Transition show={isOpen}>
        <Router>
          <SupportWidgetContainer>
            <Switch>
              <Route exact path="/" key="path" component={HomeView} />
              <Route exact path="/ask" key="path" component={ChatBotView} />
              <Route
                exact
                path="/form"
                key="path"
                component={CreateConversationView}
              />
            </Switch>
          </SupportWidgetContainer>
        </Router>
      </Transition>

      <div className="-mr-5 mt-5 flex justify-end align-baseline">
        <FloatingActionButton isOpen={isOpen} onClick={onFabClick} />
      </div>
    </div>
  );
};
